/**
 * @fileoverview gRPC-Web generated client stub for userepb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.23.4
// source: external/user/user.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var xcommon_user_pb = require('../../xcommon/user_pb.js')

var xcommon_ticket_pb = require('../../xcommon/ticket_pb.js')

var xcommon_module_pb = require('../../xcommon/module_pb.js')

var xcommon_enum_pb = require('../../xcommon/enum_pb.js')

var xcommon_common_pb = require('../../xcommon/common_pb.js')
const proto = {};
proto.userepb = require('./user_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.userepb.UserServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.userepb.UserServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CaptchaReq,
 *   !proto.xcommon.CaptchaResp>}
 */
const methodDescriptor_UserService_Captcha = new grpc.web.MethodDescriptor(
  '/userepb.UserService/Captcha',
  grpc.web.MethodType.UNARY,
  xcommon_user_pb.CaptchaReq,
  xcommon_user_pb.CaptchaResp,
  /**
   * @param {!proto.xcommon.CaptchaReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_user_pb.CaptchaResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CaptchaReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CaptchaResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CaptchaResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.captcha =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/Captcha',
      request,
      metadata || {},
      methodDescriptor_UserService_Captcha,
      callback);
};


/**
 * @param {!proto.xcommon.CaptchaReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CaptchaResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.captcha =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/Captcha',
      request,
      metadata || {},
      methodDescriptor_UserService_Captcha);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.LoginReq,
 *   !proto.userepb.LoginResp>}
 */
const methodDescriptor_UserService_Login = new grpc.web.MethodDescriptor(
  '/userepb.UserService/Login',
  grpc.web.MethodType.UNARY,
  proto.userepb.LoginReq,
  proto.userepb.LoginResp,
  /**
   * @param {!proto.userepb.LoginReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.LoginResp.deserializeBinary
);


/**
 * @param {!proto.userepb.LoginReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.LoginResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.LoginResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.login =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/Login',
      request,
      metadata || {},
      methodDescriptor_UserService_Login,
      callback);
};


/**
 * @param {!proto.userepb.LoginReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.LoginResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.login =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/Login',
      request,
      metadata || {},
      methodDescriptor_UserService_Login);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.GetTwoFactAuthQRReq,
 *   !proto.userepb.GetTwoFactAuthQRResp>}
 */
const methodDescriptor_UserService_GetTwoFactAuthQR = new grpc.web.MethodDescriptor(
  '/userepb.UserService/GetTwoFactAuthQR',
  grpc.web.MethodType.UNARY,
  proto.userepb.GetTwoFactAuthQRReq,
  proto.userepb.GetTwoFactAuthQRResp,
  /**
   * @param {!proto.userepb.GetTwoFactAuthQRReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.GetTwoFactAuthQRResp.deserializeBinary
);


/**
 * @param {!proto.userepb.GetTwoFactAuthQRReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.GetTwoFactAuthQRResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.GetTwoFactAuthQRResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.getTwoFactAuthQR =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/GetTwoFactAuthQR',
      request,
      metadata || {},
      methodDescriptor_UserService_GetTwoFactAuthQR,
      callback);
};


/**
 * @param {!proto.userepb.GetTwoFactAuthQRReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.GetTwoFactAuthQRResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.getTwoFactAuthQR =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/GetTwoFactAuthQR',
      request,
      metadata || {},
      methodDescriptor_UserService_GetTwoFactAuthQR);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.CommitTwoFactAuthCodeReq,
 *   !proto.userepb.CommitTwoFactAuthCodeResp>}
 */
const methodDescriptor_UserService_CommitTwoFactAuthCode = new grpc.web.MethodDescriptor(
  '/userepb.UserService/CommitTwoFactAuthCode',
  grpc.web.MethodType.UNARY,
  proto.userepb.CommitTwoFactAuthCodeReq,
  proto.userepb.CommitTwoFactAuthCodeResp,
  /**
   * @param {!proto.userepb.CommitTwoFactAuthCodeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.CommitTwoFactAuthCodeResp.deserializeBinary
);


/**
 * @param {!proto.userepb.CommitTwoFactAuthCodeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.CommitTwoFactAuthCodeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.CommitTwoFactAuthCodeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.commitTwoFactAuthCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/CommitTwoFactAuthCode',
      request,
      metadata || {},
      methodDescriptor_UserService_CommitTwoFactAuthCode,
      callback);
};


/**
 * @param {!proto.userepb.CommitTwoFactAuthCodeReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.CommitTwoFactAuthCodeResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.commitTwoFactAuthCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/CommitTwoFactAuthCode',
      request,
      metadata || {},
      methodDescriptor_UserService_CommitTwoFactAuthCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.EnterSystemReq,
 *   !proto.userepb.EnterSystemResp>}
 */
const methodDescriptor_UserService_EnterSystem = new grpc.web.MethodDescriptor(
  '/userepb.UserService/EnterSystem',
  grpc.web.MethodType.UNARY,
  proto.userepb.EnterSystemReq,
  proto.userepb.EnterSystemResp,
  /**
   * @param {!proto.userepb.EnterSystemReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.EnterSystemResp.deserializeBinary
);


/**
 * @param {!proto.userepb.EnterSystemReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.EnterSystemResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.EnterSystemResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.enterSystem =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/EnterSystem',
      request,
      metadata || {},
      methodDescriptor_UserService_EnterSystem,
      callback);
};


/**
 * @param {!proto.userepb.EnterSystemReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.EnterSystemResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.enterSystem =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/EnterSystem',
      request,
      metadata || {},
      methodDescriptor_UserService_EnterSystem);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CommonIn,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_UserService_Logout = new grpc.web.MethodDescriptor(
  '/userepb.UserService/Logout',
  grpc.web.MethodType.UNARY,
  xcommon_common_pb.CommonIn,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.CommonIn} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.logout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/Logout',
      request,
      metadata || {},
      methodDescriptor_UserService_Logout,
      callback);
};


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.logout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/Logout',
      request,
      metadata || {},
      methodDescriptor_UserService_Logout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CommonIn,
 *   !proto.userepb.MyQRResp>}
 */
const methodDescriptor_UserService_MyQR = new grpc.web.MethodDescriptor(
  '/userepb.UserService/MyQR',
  grpc.web.MethodType.UNARY,
  xcommon_common_pb.CommonIn,
  proto.userepb.MyQRResp,
  /**
   * @param {!proto.xcommon.CommonIn} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.MyQRResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.MyQRResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.MyQRResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.myQR =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/MyQR',
      request,
      metadata || {},
      methodDescriptor_UserService_MyQR,
      callback);
};


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.MyQRResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.myQR =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/MyQR',
      request,
      metadata || {},
      methodDescriptor_UserService_MyQR);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.VerifyPasswordReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_UserService_VerifyPassword = new grpc.web.MethodDescriptor(
  '/userepb.UserService/VerifyPassword',
  grpc.web.MethodType.UNARY,
  proto.userepb.VerifyPasswordReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.userepb.VerifyPasswordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.userepb.VerifyPasswordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.verifyPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/VerifyPassword',
      request,
      metadata || {},
      methodDescriptor_UserService_VerifyPassword,
      callback);
};


/**
 * @param {!proto.userepb.VerifyPasswordReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.verifyPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/VerifyPassword',
      request,
      metadata || {},
      methodDescriptor_UserService_VerifyPassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.ChangePasswordReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_UserService_ChangePassword = new grpc.web.MethodDescriptor(
  '/userepb.UserService/ChangePassword',
  grpc.web.MethodType.UNARY,
  proto.userepb.ChangePasswordReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.userepb.ChangePasswordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.userepb.ChangePasswordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.changePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_UserService_ChangePassword,
      callback);
};


/**
 * @param {!proto.userepb.ChangePasswordReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.changePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_UserService_ChangePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CommonIn,
 *   !proto.userepb.PreCreateUserResp>}
 */
const methodDescriptor_UserService_PreCreateUser = new grpc.web.MethodDescriptor(
  '/userepb.UserService/PreCreateUser',
  grpc.web.MethodType.UNARY,
  xcommon_common_pb.CommonIn,
  proto.userepb.PreCreateUserResp,
  /**
   * @param {!proto.xcommon.CommonIn} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.PreCreateUserResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.PreCreateUserResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.PreCreateUserResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.preCreateUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/PreCreateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_PreCreateUser,
      callback);
};


/**
 * @param {!proto.xcommon.CommonIn} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.PreCreateUserResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.preCreateUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/PreCreateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_PreCreateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.GetOutSourceInfoReq,
 *   !proto.userepb.GetOutSourceInfoResp>}
 */
const methodDescriptor_UserService_GetOutSourceInfo = new grpc.web.MethodDescriptor(
  '/userepb.UserService/GetOutSourceInfo',
  grpc.web.MethodType.UNARY,
  proto.userepb.GetOutSourceInfoReq,
  proto.userepb.GetOutSourceInfoResp,
  /**
   * @param {!proto.userepb.GetOutSourceInfoReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.GetOutSourceInfoResp.deserializeBinary
);


/**
 * @param {!proto.userepb.GetOutSourceInfoReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.GetOutSourceInfoResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.GetOutSourceInfoResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.getOutSourceInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/GetOutSourceInfo',
      request,
      metadata || {},
      methodDescriptor_UserService_GetOutSourceInfo,
      callback);
};


/**
 * @param {!proto.userepb.GetOutSourceInfoReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.GetOutSourceInfoResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.getOutSourceInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/GetOutSourceInfo',
      request,
      metadata || {},
      methodDescriptor_UserService_GetOutSourceInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.CreateUserReq,
 *   !proto.userepb.CreateUserResp>}
 */
const methodDescriptor_UserService_CreateUser = new grpc.web.MethodDescriptor(
  '/userepb.UserService/CreateUser',
  grpc.web.MethodType.UNARY,
  proto.userepb.CreateUserReq,
  proto.userepb.CreateUserResp,
  /**
   * @param {!proto.userepb.CreateUserReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.CreateUserResp.deserializeBinary
);


/**
 * @param {!proto.userepb.CreateUserReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.CreateUserResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.CreateUserResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.createUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/CreateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_CreateUser,
      callback);
};


/**
 * @param {!proto.userepb.CreateUserReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.CreateUserResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.createUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/CreateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_CreateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.UpdateUserReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_UserService_UpdateUser = new grpc.web.MethodDescriptor(
  '/userepb.UserService/UpdateUser',
  grpc.web.MethodType.UNARY,
  proto.userepb.UpdateUserReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.userepb.UpdateUserReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.userepb.UpdateUserReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.updateUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/UpdateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUser,
      callback);
};


/**
 * @param {!proto.userepb.UpdateUserReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.updateUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/UpdateUser',
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.UpdateUserStatusReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_UserService_UpdateUserStatus = new grpc.web.MethodDescriptor(
  '/userepb.UserService/UpdateUserStatus',
  grpc.web.MethodType.UNARY,
  proto.userepb.UpdateUserStatusReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.userepb.UpdateUserStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.userepb.UpdateUserStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.updateUserStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/UpdateUserStatus',
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUserStatus,
      callback);
};


/**
 * @param {!proto.userepb.UpdateUserStatusReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.updateUserStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/UpdateUserStatus',
      request,
      metadata || {},
      methodDescriptor_UserService_UpdateUserStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.BatchUpdateUserWorkStatusReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_UserService_BatchUpdateUserWorkStatus = new grpc.web.MethodDescriptor(
  '/userepb.UserService/BatchUpdateUserWorkStatus',
  grpc.web.MethodType.UNARY,
  proto.userepb.BatchUpdateUserWorkStatusReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.userepb.BatchUpdateUserWorkStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.userepb.BatchUpdateUserWorkStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.batchUpdateUserWorkStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/BatchUpdateUserWorkStatus',
      request,
      metadata || {},
      methodDescriptor_UserService_BatchUpdateUserWorkStatus,
      callback);
};


/**
 * @param {!proto.userepb.BatchUpdateUserWorkStatusReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.batchUpdateUserWorkStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/BatchUpdateUserWorkStatus',
      request,
      metadata || {},
      methodDescriptor_UserService_BatchUpdateUserWorkStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.DeleteUserReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_UserService_DeleteUser = new grpc.web.MethodDescriptor(
  '/userepb.UserService/DeleteUser',
  grpc.web.MethodType.UNARY,
  proto.userepb.DeleteUserReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.userepb.DeleteUserReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.userepb.DeleteUserReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.deleteUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_UserService_DeleteUser,
      callback);
};


/**
 * @param {!proto.userepb.DeleteUserReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.deleteUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_UserService_DeleteUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.SearchUserReq,
 *   !proto.userepb.GetUserListResp>}
 */
const methodDescriptor_UserService_SearchUser = new grpc.web.MethodDescriptor(
  '/userepb.UserService/SearchUser',
  grpc.web.MethodType.UNARY,
  proto.userepb.SearchUserReq,
  proto.userepb.GetUserListResp,
  /**
   * @param {!proto.userepb.SearchUserReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.GetUserListResp.deserializeBinary
);


/**
 * @param {!proto.userepb.SearchUserReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.GetUserListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.GetUserListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.searchUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/SearchUser',
      request,
      metadata || {},
      methodDescriptor_UserService_SearchUser,
      callback);
};


/**
 * @param {!proto.userepb.SearchUserReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.GetUserListResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.searchUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/SearchUser',
      request,
      metadata || {},
      methodDescriptor_UserService_SearchUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.SearchUserMiniReq,
 *   !proto.userepb.GetUserListMiniResp>}
 */
const methodDescriptor_UserService_SearchUserMini = new grpc.web.MethodDescriptor(
  '/userepb.UserService/SearchUserMini',
  grpc.web.MethodType.UNARY,
  proto.userepb.SearchUserMiniReq,
  proto.userepb.GetUserListMiniResp,
  /**
   * @param {!proto.userepb.SearchUserMiniReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.GetUserListMiniResp.deserializeBinary
);


/**
 * @param {!proto.userepb.SearchUserMiniReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.GetUserListMiniResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.GetUserListMiniResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.searchUserMini =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/SearchUserMini',
      request,
      metadata || {},
      methodDescriptor_UserService_SearchUserMini,
      callback);
};


/**
 * @param {!proto.userepb.SearchUserMiniReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.GetUserListMiniResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.searchUserMini =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/SearchUserMini',
      request,
      metadata || {},
      methodDescriptor_UserService_SearchUserMini);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.GetUserByEmployeeIDReq,
 *   !proto.userepb.GetUserResp>}
 */
const methodDescriptor_UserService_GetUserByEmployeeID = new grpc.web.MethodDescriptor(
  '/userepb.UserService/GetUserByEmployeeID',
  grpc.web.MethodType.UNARY,
  proto.userepb.GetUserByEmployeeIDReq,
  proto.userepb.GetUserResp,
  /**
   * @param {!proto.userepb.GetUserByEmployeeIDReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.GetUserResp.deserializeBinary
);


/**
 * @param {!proto.userepb.GetUserByEmployeeIDReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.GetUserResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.GetUserResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.getUserByEmployeeID =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/GetUserByEmployeeID',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserByEmployeeID,
      callback);
};


/**
 * @param {!proto.userepb.GetUserByEmployeeIDReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.GetUserResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.getUserByEmployeeID =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/GetUserByEmployeeID',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserByEmployeeID);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.GetUserByEmailReq,
 *   !proto.userepb.GetUserResp>}
 */
const methodDescriptor_UserService_GetUserByEmail = new grpc.web.MethodDescriptor(
  '/userepb.UserService/GetUserByEmail',
  grpc.web.MethodType.UNARY,
  proto.userepb.GetUserByEmailReq,
  proto.userepb.GetUserResp,
  /**
   * @param {!proto.userepb.GetUserByEmailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.GetUserResp.deserializeBinary
);


/**
 * @param {!proto.userepb.GetUserByEmailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.GetUserResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.GetUserResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.getUserByEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/GetUserByEmail',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserByEmail,
      callback);
};


/**
 * @param {!proto.userepb.GetUserByEmailReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.GetUserResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.getUserByEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/GetUserByEmail',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserByEmail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.GetUserByMobileReq,
 *   !proto.userepb.GetUserResp>}
 */
const methodDescriptor_UserService_GetUserByMobile = new grpc.web.MethodDescriptor(
  '/userepb.UserService/GetUserByMobile',
  grpc.web.MethodType.UNARY,
  proto.userepb.GetUserByMobileReq,
  proto.userepb.GetUserResp,
  /**
   * @param {!proto.userepb.GetUserByMobileReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.GetUserResp.deserializeBinary
);


/**
 * @param {!proto.userepb.GetUserByMobileReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.GetUserResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.GetUserResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.getUserByMobile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/GetUserByMobile',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserByMobile,
      callback);
};


/**
 * @param {!proto.userepb.GetUserByMobileReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.GetUserResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.getUserByMobile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/GetUserByMobile',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserByMobile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.GetUserListReq,
 *   !proto.userepb.GetUserListResp>}
 */
const methodDescriptor_UserService_GetUserList = new grpc.web.MethodDescriptor(
  '/userepb.UserService/GetUserList',
  grpc.web.MethodType.UNARY,
  proto.userepb.GetUserListReq,
  proto.userepb.GetUserListResp,
  /**
   * @param {!proto.userepb.GetUserListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.GetUserListResp.deserializeBinary
);


/**
 * @param {!proto.userepb.GetUserListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.GetUserListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.GetUserListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.getUserList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/GetUserList',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserList,
      callback);
};


/**
 * @param {!proto.userepb.GetUserListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.GetUserListResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.getUserList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/GetUserList',
      request,
      metadata || {},
      methodDescriptor_UserService_GetUserList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.GetUserListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_UserService_DownloadUserExcel = new grpc.web.MethodDescriptor(
  '/userepb.UserService/DownloadUserExcel',
  grpc.web.MethodType.UNARY,
  proto.userepb.GetUserListReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.userepb.GetUserListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.userepb.GetUserListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.downloadUserExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/DownloadUserExcel',
      request,
      metadata || {},
      methodDescriptor_UserService_DownloadUserExcel,
      callback);
};


/**
 * @param {!proto.userepb.GetUserListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.downloadUserExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/DownloadUserExcel',
      request,
      metadata || {},
      methodDescriptor_UserService_DownloadUserExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.GetOptionsForAttendanceReportReq,
 *   !proto.userepb.GetOptionsForAttendanceReportResp>}
 */
const methodDescriptor_UserService_GetOptionsForAttendanceReport = new grpc.web.MethodDescriptor(
  '/userepb.UserService/GetOptionsForAttendanceReport',
  grpc.web.MethodType.UNARY,
  proto.userepb.GetOptionsForAttendanceReportReq,
  proto.userepb.GetOptionsForAttendanceReportResp,
  /**
   * @param {!proto.userepb.GetOptionsForAttendanceReportReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.GetOptionsForAttendanceReportResp.deserializeBinary
);


/**
 * @param {!proto.userepb.GetOptionsForAttendanceReportReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.GetOptionsForAttendanceReportResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.GetOptionsForAttendanceReportResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.getOptionsForAttendanceReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/GetOptionsForAttendanceReport',
      request,
      metadata || {},
      methodDescriptor_UserService_GetOptionsForAttendanceReport,
      callback);
};


/**
 * @param {!proto.userepb.GetOptionsForAttendanceReportReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.GetOptionsForAttendanceReportResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.getOptionsForAttendanceReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/GetOptionsForAttendanceReport',
      request,
      metadata || {},
      methodDescriptor_UserService_GetOptionsForAttendanceReport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.ListGroupAttendanceReq,
 *   !proto.userepb.ListGroupAttendanceResp>}
 */
const methodDescriptor_UserService_ListGroupAttendance = new grpc.web.MethodDescriptor(
  '/userepb.UserService/ListGroupAttendance',
  grpc.web.MethodType.UNARY,
  proto.userepb.ListGroupAttendanceReq,
  proto.userepb.ListGroupAttendanceResp,
  /**
   * @param {!proto.userepb.ListGroupAttendanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.ListGroupAttendanceResp.deserializeBinary
);


/**
 * @param {!proto.userepb.ListGroupAttendanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.ListGroupAttendanceResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.ListGroupAttendanceResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.listGroupAttendance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/ListGroupAttendance',
      request,
      metadata || {},
      methodDescriptor_UserService_ListGroupAttendance,
      callback);
};


/**
 * @param {!proto.userepb.ListGroupAttendanceReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.ListGroupAttendanceResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.listGroupAttendance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/ListGroupAttendance',
      request,
      metadata || {},
      methodDescriptor_UserService_ListGroupAttendance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.ListPersonalAttendancePreRangeReq,
 *   !proto.userepb.ListPersonalAttendancePreRangeResp>}
 */
const methodDescriptor_UserService_ListPersonalAttendancePreRange = new grpc.web.MethodDescriptor(
  '/userepb.UserService/ListPersonalAttendancePreRange',
  grpc.web.MethodType.UNARY,
  proto.userepb.ListPersonalAttendancePreRangeReq,
  proto.userepb.ListPersonalAttendancePreRangeResp,
  /**
   * @param {!proto.userepb.ListPersonalAttendancePreRangeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.ListPersonalAttendancePreRangeResp.deserializeBinary
);


/**
 * @param {!proto.userepb.ListPersonalAttendancePreRangeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.ListPersonalAttendancePreRangeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.ListPersonalAttendancePreRangeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.listPersonalAttendancePreRange =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/ListPersonalAttendancePreRange',
      request,
      metadata || {},
      methodDescriptor_UserService_ListPersonalAttendancePreRange,
      callback);
};


/**
 * @param {!proto.userepb.ListPersonalAttendancePreRangeReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.ListPersonalAttendancePreRangeResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.listPersonalAttendancePreRange =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/ListPersonalAttendancePreRange',
      request,
      metadata || {},
      methodDescriptor_UserService_ListPersonalAttendancePreRange);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.ListPersonalAttendancePreRangeReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_UserService_DownloadPersonalAttendancePreRangeExcel = new grpc.web.MethodDescriptor(
  '/userepb.UserService/DownloadPersonalAttendancePreRangeExcel',
  grpc.web.MethodType.UNARY,
  proto.userepb.ListPersonalAttendancePreRangeReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.userepb.ListPersonalAttendancePreRangeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.userepb.ListPersonalAttendancePreRangeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.downloadPersonalAttendancePreRangeExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/DownloadPersonalAttendancePreRangeExcel',
      request,
      metadata || {},
      methodDescriptor_UserService_DownloadPersonalAttendancePreRangeExcel,
      callback);
};


/**
 * @param {!proto.userepb.ListPersonalAttendancePreRangeReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.downloadPersonalAttendancePreRangeExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/DownloadPersonalAttendancePreRangeExcel',
      request,
      metadata || {},
      methodDescriptor_UserService_DownloadPersonalAttendancePreRangeExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.ListPersonalAttendancePreDayReq,
 *   !proto.userepb.ListPersonalAttendancePreDayResp>}
 */
const methodDescriptor_UserService_ListPersonalAttendancePreDay = new grpc.web.MethodDescriptor(
  '/userepb.UserService/ListPersonalAttendancePreDay',
  grpc.web.MethodType.UNARY,
  proto.userepb.ListPersonalAttendancePreDayReq,
  proto.userepb.ListPersonalAttendancePreDayResp,
  /**
   * @param {!proto.userepb.ListPersonalAttendancePreDayReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.ListPersonalAttendancePreDayResp.deserializeBinary
);


/**
 * @param {!proto.userepb.ListPersonalAttendancePreDayReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.ListPersonalAttendancePreDayResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.ListPersonalAttendancePreDayResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.listPersonalAttendancePreDay =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/ListPersonalAttendancePreDay',
      request,
      metadata || {},
      methodDescriptor_UserService_ListPersonalAttendancePreDay,
      callback);
};


/**
 * @param {!proto.userepb.ListPersonalAttendancePreDayReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.ListPersonalAttendancePreDayResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.listPersonalAttendancePreDay =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/ListPersonalAttendancePreDay',
      request,
      metadata || {},
      methodDescriptor_UserService_ListPersonalAttendancePreDay);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.ListPersonalAttendancePreDayReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_UserService_DownloadPersonalAttendancePreDayExcel = new grpc.web.MethodDescriptor(
  '/userepb.UserService/DownloadPersonalAttendancePreDayExcel',
  grpc.web.MethodType.UNARY,
  proto.userepb.ListPersonalAttendancePreDayReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.userepb.ListPersonalAttendancePreDayReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.userepb.ListPersonalAttendancePreDayReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.downloadPersonalAttendancePreDayExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/DownloadPersonalAttendancePreDayExcel',
      request,
      metadata || {},
      methodDescriptor_UserService_DownloadPersonalAttendancePreDayExcel,
      callback);
};


/**
 * @param {!proto.userepb.ListPersonalAttendancePreDayReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.downloadPersonalAttendancePreDayExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/DownloadPersonalAttendancePreDayExcel',
      request,
      metadata || {},
      methodDescriptor_UserService_DownloadPersonalAttendancePreDayExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.StatementOfSalaryReq,
 *   !proto.userepb.StatementOfSalaryResp>}
 */
const methodDescriptor_UserService_StatementOfSalary = new grpc.web.MethodDescriptor(
  '/userepb.UserService/StatementOfSalary',
  grpc.web.MethodType.UNARY,
  proto.userepb.StatementOfSalaryReq,
  proto.userepb.StatementOfSalaryResp,
  /**
   * @param {!proto.userepb.StatementOfSalaryReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.StatementOfSalaryResp.deserializeBinary
);


/**
 * @param {!proto.userepb.StatementOfSalaryReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.StatementOfSalaryResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.StatementOfSalaryResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.statementOfSalary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/StatementOfSalary',
      request,
      metadata || {},
      methodDescriptor_UserService_StatementOfSalary,
      callback);
};


/**
 * @param {!proto.userepb.StatementOfSalaryReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.StatementOfSalaryResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.statementOfSalary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/StatementOfSalary',
      request,
      metadata || {},
      methodDescriptor_UserService_StatementOfSalary);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.StatementOfSalaryReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_UserService_DownloadStatementOfSalary = new grpc.web.MethodDescriptor(
  '/userepb.UserService/DownloadStatementOfSalary',
  grpc.web.MethodType.UNARY,
  proto.userepb.StatementOfSalaryReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.userepb.StatementOfSalaryReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.userepb.StatementOfSalaryReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.downloadStatementOfSalary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/DownloadStatementOfSalary',
      request,
      metadata || {},
      methodDescriptor_UserService_DownloadStatementOfSalary,
      callback);
};


/**
 * @param {!proto.userepb.StatementOfSalaryReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.downloadStatementOfSalary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/DownloadStatementOfSalary',
      request,
      metadata || {},
      methodDescriptor_UserService_DownloadStatementOfSalary);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.userepb.BatchGetLoginInfoReq,
 *   !proto.userepb.BatchGetLoginInfoResp>}
 */
const methodDescriptor_UserService_BatchGetLoginInfo = new grpc.web.MethodDescriptor(
  '/userepb.UserService/BatchGetLoginInfo',
  grpc.web.MethodType.UNARY,
  proto.userepb.BatchGetLoginInfoReq,
  proto.userepb.BatchGetLoginInfoResp,
  /**
   * @param {!proto.userepb.BatchGetLoginInfoReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.userepb.BatchGetLoginInfoResp.deserializeBinary
);


/**
 * @param {!proto.userepb.BatchGetLoginInfoReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.userepb.BatchGetLoginInfoResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.userepb.BatchGetLoginInfoResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.userepb.UserServiceClient.prototype.batchGetLoginInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/userepb.UserService/BatchGetLoginInfo',
      request,
      metadata || {},
      methodDescriptor_UserService_BatchGetLoginInfo,
      callback);
};


/**
 * @param {!proto.userepb.BatchGetLoginInfoReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.userepb.BatchGetLoginInfoResp>}
 *     Promise that resolves to the response
 */
proto.userepb.UserServicePromiseClient.prototype.batchGetLoginInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/userepb.UserService/BatchGetLoginInfo',
      request,
      metadata || {},
      methodDescriptor_UserService_BatchGetLoginInfo);
};


module.exports = proto.userepb;

